// extracted by mini-css-extract-plugin
export default {"wrap":"CompactColorPicker_wrap__cemSB","swatch":"CompactColorPicker_swatch__3gmMb","hex":"CompactColorPicker_hex__QNBQi","popover":"CompactColorPicker_popover__Vn5Y1"};